import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconAlignedProps, IconRender } from '../types.ts';

const Arrow = React.forwardRef<SVGSVGElement | null, IconAlignedProps>(function Arrow({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      d='M11.2068 5.41322L5.38327 11.6551C5.19425 11.8577 4.87651 11.8679 4.67483 11.6779L4.31483 11.3388C4.11452 11.1501 4.10435 10.835 4.29209 10.6337L11.0461 3.39466C11.537 2.86845 12.3683 2.86845 12.8592 3.39466L19.6132 10.6337C19.8009 10.835 19.7908 11.1501 19.5904 11.3388L19.2304 11.6779C19.0288 11.8679 18.711 11.8577 18.522 11.6551L12.698 5.41277L12.698 20.5C12.698 20.7761 12.4742 21 12.198 21L11.7068 21C11.4307 21 11.2068 20.7761 11.2068 20.5L11.2068 5.41322Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'arrow-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Arrow;
